import React from 'react'
import TextField from '../Textfield';
import { makeStyles } from '@material-ui/core/styles';
import { Material, ProductInputDataRequiredFields } from '../../redux/product/productTypes';
import { useIntl, FormattedHTMLMessage } from 'react-intl';
import { Tooltip, Grid, Divider } from '@material-ui/core';
import isFieldEmpty from '../../service/IsFieldEmpty';
import { ComboBox } from '@ktr/ktr-materialui-react';
import InfoIcon from '@material-ui/icons/Info';

export const useStyleLocal = makeStyles({
    basicDataPanel: {
        minWidth: "200px",
    },
    localSelect: {
        minWidth: "300px"
    },
    formControl: {
        marginTop: "20px",
        fontSize: "0.875rem"
    },
    textbox: {
        minWidth: "150px"
    }
});

export interface Props {
    inputChanged(productInputData: any): any,
    yieldStrengthHub: number | null | undefined,
    materialDensityHub: number | null | undefined,
    hubInnerDiameter: number | null | undefined,
    hubOuterDiameter: number | null | undefined,
    errorFields?: ProductInputDataRequiredFields,
    hubMaterial?: string,
    materials:Array<Material>
}

export default function Hub(props: Props) {
    

    const [hubOuterDiameterEnter, setHubOuterDiameterEnter] = React.useState(false);
    const { formatMessage: f } = useIntl();

    return (

        //<Panel title={f({id: 'app.hub', defaultMessage: 'Hub'})} className={classes.basicDataPanel}>
        <Grid item xs={12} style={{marginTop: "20px"}}>
            <b>{f({id: 'app.hub', defaultMessage: 'Hub'})}</b>
            <Divider></Divider>

            <form autoComplete="off">

                <Grid container>
                    <Grid item xs={12} md={7} style={{paddingTop:"18px", marginLeft: "5px"}}>
                        {f({ id: 'app.shaft.material', defaultMessage: 'Material' })}
                    </Grid>
                    <Grid item xs={12} sm={3} style={{boxSizing: "unset"}}>
                        <ComboBox
                        freeSolo={true}
                        //value={props.shaftDiameter_d === null ? "" : Object.assign({}, props.clampexSizes[props.clampexSizes.findIndex(value => value.shaftDiameter_d === props.shaftDiameter_d)])}
                        value={props.hubMaterial === null ? "" : props.hubMaterial}
                        getOptionLabel={(value: Material) => String(value.name)}
                        errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                        //error={props.errorFields === undefined || (props.errorFields.shaftDiameter_d === true && props.shaftDiameter_d !== null) ? false : props.errorFields.shaftDiameter_d}
                        error={props.errorFields !== undefined && props.errorFields.shaftDiameter_d && isFieldEmpty(props.hubMaterial)}
                        options={props.materials}
                        onChange={(event, value: Material) => props.inputChanged({ hubMaterial: value.name === "" && value !== undefined ? undefined : value.name,
                                                                                   yieldStrengthHub: value.yieldstrength === undefined ? undefined : value.yieldstrength})}
                        onInputChange={(e,v) => props.inputChanged({ hubMaterial: e.target.value === "" ? undefined : e.target.value })} 
                        />
                    </Grid>
                    <Grid item sm={2}>
                    
                    </Grid>

                </Grid>

                

                <TextField
                    //error={props.errorFields === undefined || (props.errorFields.yieldStrengthHub === true && props.yieldStrengthHub !== null) ? false : props.errorFields.yieldStrengthHub}
                    error={props.errorFields !== undefined && props.errorFields.yieldStrengthHub && isFieldEmpty(props.yieldStrengthHub)}
                    type="number"
                    errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                    value={props.yieldStrengthHub === null ? "" : props.yieldStrengthHub}
                    onChange={e => props.inputChanged({ yieldStrengthHub: e.target.value === "" ? null : Number(e.target.value) })}
                    labelBefore={<FormattedHTMLMessage id="app.shaft.yieldstrength.hub" defaultMessage="Yieldstrength"></FormattedHTMLMessage>}
                    labelAfter={
                            
                            <Grid container>
                                <Grid item>
                                N/mm²
                                </Grid>
                                <Grid item>
                                { props.hubMaterial === "" || props.hubMaterial === undefined ? "" :
                                <Tooltip style={{marginLeft: "10px"}} title={f({ id: 'app.yieldstrength.info', defaultMessage: 'Attention' })} arrow>
                                    <InfoIcon/>
                                </Tooltip>
                                }
                                </Grid>
                            </Grid>
                    } />

                <Tooltip title={f({ id: 'app.hub.innerdiameter.info', defaultMessage: 'Not editable. Resulting from shaftdiameter d.' })}>
                    <div>
                        <TextField
                            //error={props.errorFields === undefined || (props.errorFields.hubInnerDiameter_D === true && props.hubInnerDiameter !== null) ?
                              //  false : props.errorFields.hubInnerDiameter_D}
                            //error={props.errorFields !== undefined && props.errorFields.hubInnerDiameter_D && isFieldEmpty(props.hubInnerDiameter)}
                            type="number"
                            readonly={true}
                            errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                            value={props.hubInnerDiameter === null || props.hubInnerDiameter === undefined ? "" : props.hubInnerDiameter}

                            //onChange={e => {props.inputChanged({ hubInnerDiameter: e.target.value === "" ? null : Number(e.target.value)})}} 

                            labelBefore={f({ id: 'app.hub.innerdiameter', defaultMessage: 'Required' })}
                            labelAfter="mm" />
                    </div>
                </Tooltip>

                <TextField
                    error={
                        (() => {
                            //@ts-ignore // HubOuterdiameter muss immer größer sein als hubInnerDiameter!
                            // Außerdem wird hier noch geprüft der Cursor gerade in der Texbox ist. Wenn nicht soll die Fehlermeldung auch nicht angezeigt werden
                            if (props.hubOuterDiameter < props.hubInnerDiameter && hubOuterDiameterEnter)
                                return true;
                            //Hier wird geprüft ob dieses Feld im Redux store unter errorfields aufgeführt ist und das Feld null (leer ist). 
                            // Diese condition ist dafür, dass die Fehlermeldung verschwindet sobald Zahlen in die textbox eingetippt werden.
                            else if (props.errorFields !== undefined && props.errorFields.hubOuterDiameter && isFieldEmpty(props.hubOuterDiameter))//(props.errorFields === undefined || (props.errorFields.hubOuterDiameter === true && props.hubOuterDiameter !== null))
                                return true;
                            else
                                //wenn beides falsch ist wird der wert des Error fields ausgegeben und wenn dieser nicht definiert ist -> False
                                return false; //props.errorFields.hubOuterDiameter || false;
                        })()
                    }
                    type="number"
                    errorText={
                        //@ts-ignore
                        props.hubOuterDiameter < props.hubInnerDiameter && hubOuterDiameterEnter ?
                            f({ id: 'app.error.HubOuterDiameterError', defaultMessage: 'Have to be bigger then D.' }) : f({ id: 'app.error.required', defaultMessage: 'Required' })
                    }
                    value={props.hubOuterDiameter === null ? "" : props.hubOuterDiameter}
                    onChange={e => {
                        props.inputChanged({ hubOuterDiameter: e.target.value === "" ? null : Number(e.target.value) })
                        setHubOuterDiameterEnter(true);
                    }
                    }
                    onBlur={e => {
                        //setHubOuterDiameterEnter(false) 
                    }
                    }
                    labelBefore={<FormattedHTMLMessage id="app.hub.outerdiameter" defaultMessage="Hubouterdiameter d"></FormattedHTMLMessage>}
                    labelAfter="mm" />
            </form>
        </Grid>
        //</Panel >

    )
}